import {Form, FormField} from '@src/Api/Umbraco/interface/UmbracoTypes';

const getDefaultValueForField = (
  field: FormField,
): string | boolean | any[] | undefined => {
  const defaultValue = field.settings?.defaultValue;
  if (typeof defaultValue !== 'undefined') return defaultValue;

  switch (field.type) {
    case 'checkbox':
    case 'dataConsent':
      return false;
    case 'checkboxList':
      return [];
    case 'dropdown':
    case 'password':
    case 'text':
    case 'textarea':
    case 'radio':
    case 'select':
      return '';
    case 'date':
      return '';
    case 'hidden':
      return '';
    case 'recaptcha2':
    case 'titleAndDescription':
      return undefined;
    default:
      return field.settings?.defaultValue ?? '';
  }
};

const buildInitialValues = (
  fields: FormField[],
  initialValues: Record<string, any> = {},
): Record<string, any> => {
  const values = {...initialValues};
  fields.forEach(field => {
    if (!(field.alias in values)) {
      values[field.alias] = getDefaultValueForField(field);
    }
  });
  return values;
};

export const completeInitialValuesWithDefaults = (
  filteredForm: Form,
  initialValues: Record<string, any> = {},
): Record<string, any> => {
  const allFields: FormField[] = [];
  filteredForm.pages.forEach(page =>
    page.fieldsets.forEach(fieldset =>
      fieldset.columns.forEach(column =>
        column.fields.forEach(field => allFields.push(field)),
      ),
    ),
  );
  return buildInitialValues(allFields, initialValues);
};
